import React from "react";
import { Text as RText } from "rebass";
import styled from "styled-components";

const getColumnGap = (space, theme) => {
  return theme.space[space];
};

const Text = styled(RText)`
  columns: ${props => props.columns || 2};
  column-gap: ${({ theme, gutter }) => getColumnGap(gutter, theme)};
  h3 {
    font-weight: bold;
  }
`;

export default props => {
  const { html, ...rest } = props;
  return <Text {...rest} dangerouslySetInnerHTML={{ __html: html }} />;
};



// WEBPACK FOOTER //
// ./src/components/text.js